import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../models/User';
import { UserService } from '../services/User/User.service';
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, concatMap, debounceTime, filter, map, Observable, switchMap } from 'rxjs';
import { HttpService } from '../services/http/http.service';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  login = new User;
  passwordType: string = 'password';

  onCheckExistedField = new BehaviorSubject<string>('');

  isExistUsername$: Observable<boolean>
  isExistEmail$: Observable<boolean>

  private readonly checkExistedFieldEndpoint = 'Authentication/NameOrEmailExist'

  constructor(private userService: UserService, private _router: Router, private elementRef: ElementRef, private toastr: ToastrService, private http: HttpService) {
    const user = localStorage.getItem('user');
    if (user != null) {
      let now = new Date();
      let jsontoken = JSON.parse(user);
      let expired = new Date(jsontoken.expiredAt);
      if (now < expired) {
        this._router.navigate(['menu/report']);
      }
    }
  }

  emitFieldChange(prop: string) {
    this.onCheckExistedField.next(prop)
  }
  ngOnInit(): void {
    //change background color to light blue
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#dfeffc';
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
  }

  getCookies() {
    let Authorization = localStorage.getItem("Authorization");
    if (Authorization != null) {
      let model = JSON.parse(Authorization);
      this.login.Username = model.Username;
    }
  }

  DoLogin(): void {
    this.userService.Login(this.login.Username,this.login.Password).subscribe(result=>{
        if(result.User.access_token != null)
        {
          localStorage.removeItem("user");
          const user = JSON.stringify(result.User);
          localStorage.setItem('user', user);
          this._router.navigate(['menu/report']);
        }
    });
  }

  redirectForgetPass() {
    window.open(this.makeForgotPassLink(), "_blank");
  }

  makeForgotPassLink() {
    var link = this.login.Email;
    if (link[(link.length - 1)] == '/') {
      link = link.slice(0, -1);
    }
    if (!link.includes('https://')) {
      link = 'https://' + link;
    }

    return link + "/ForgotPassword";
  }

  //Function: hideShowPassword() will toggle the password visibility with the eye icon
  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
  }

  public onKeyDown(event: KeyboardEvent) {
    if ((event.code == "Enter") || (event.code == "NumpadEnter")) {
      this.DoLogin();
    }
  }
}
